export default "__VITE_ASSET__b6d3b402__"